import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { getActivities } from '../../redux/activities/selectors';
import { loadActivities, RESET_LOAD_ACTIVITIES } from '../../redux/activities/actions';
import { action } from '../../redux/helpers';

export const useActivities = (cycleId) => {
  const dispatch = useDispatch();
  const firstLoad = useRef(false);
  const [resetCalled, setResetCalled] = useState(false);
  const activities = useSelector(getActivities);
  const currPage = useSelector((s) => s.activities.currActivitiesPage);
  const hasMore = useSelector((s) => s.activities.hasMoreActivities);
  const loading = useSelector((s) => s.activities.loadActivitiesPending);

  useEffect(() => {
    if (loading) {
      firstLoad.current = true;
    }
  }, [loading]);

  const noResults = useMemo(() => {
    return (
      firstLoad.current &&
      !loading &&
      !hasMore &&
      _.get(activities, 'length', 0) == 0
    );
  }, [loading, hasMore, activities]);

  // Reset list on mount
  useEffect(() => {
    dispatch(action(RESET_LOAD_ACTIVITIES));
    setResetCalled(true);
  }, []);

  const loadMore = useCallback(() => {
    dispatch(loadActivities(cycleId, currPage + 1));
  }, [cycleId, currPage]);

  return {
    // Ignore redux list until first load
    activities: firstLoad.current ? activities : [],
    hasMore: resetCalled && hasMore,
    loading,
    noResults,
    loadMore,
  };
};
